import {XdSentry} from "../../libs/sentry/xd-sentry";

// Logs the failover incident. If there is no failover host, then this will be marked as a critical issue.
export const logFailoverIncident = ({retryHost = "", ccHost, exception = {}}) => {

    let errorTitle = "Error communicating with Customer's Canvas.";
    let breadcrumbMessage = "A failover incident has occurred when attempting communication with " + ccHost + ".";

    if (!retryHost) {
        errorTitle += " No failover host is available!";
        breadcrumbMessage += " No failover host is available!";
    } else if (retryHost === ccHost) {
        errorTitle += " Request retried against same host.";
        breadcrumbMessage += " The request is being retried with the same host after validating connectivity. If this error persists, reboot " + ccHost + ".";
    } else {
        errorTitle += " Request retried against failover host.";
        breadcrumbMessage += " After refresh, the editor will be loaded from " + retryHost + ".";
    }

    XdSentry.addBreadcrumb({
        category: "custcanv",
        message: breadcrumbMessage,
        level: (!!retryHost) ? XdSentry.Severity.Error : XdSentry.Severity.Critical,
        data: {
            exception,
        }
    });
    XdSentry.captureMessage(
        errorTitle,
        (!!retryHost) ? XdSentry.Severity.Error : XdSentry.Severity.Critical
    );

};
